import * as React from 'react';

import useFiltersHeight from './useFiltersHeight';

/*
 * Screen-root div that keeps the --filters CSS variable equal to the real
 * rendered height of everything above the screen's .beacon-table (see
 * useFiltersHeight). Lets class components use the hook.
 */
export const FiltersHeightDiv: React.FC<{ className: string }> = ({
    className,
    children
}) => {
    const screenRef = useFiltersHeight([]);
    return (
        <div className={className} ref={screenRef}>
            {children}
        </div>
    );
};
